import { useDispatch } from 'react-redux'
import { setStakedAmount, setTier } from '../modules/staking/actions'
import { amountFromWei, toFixed } from '../utils/amount'
import { setBalanceLPT } from '../modules/web3/actions'
import { STAKED_DECIMALS } from '../page_components/Staking'
import * as Staking from '../contracts/stakingOld'
import Big from 'big.js'
import { ethers } from 'ethers'

export interface IStakingContractOld {
  withdrawAll: () => Promise<void>
  balanceOf: () => Promise<void>
  getTier: () => Promise<void>
  getStakedAmount: (account: string) => Promise<void>
}

const initContract = (provider: ethers.BrowserProvider, account: string) => {
  if (provider) {
    return new ethers.Contract(
      Staking.address,
      Staking.abi as ethers.InterfaceAbi,
      provider,
    )
  }
}

const useStakingContract = (
  provider: ethers.BrowserProvider,
  account: string,
): IStakingContractOld => {
  const contract = initContract(provider, account)
  const dispatch = useDispatch()
  async function withdrawAll() {
    return await contract?.unstake(0n)
  }
  async function balanceOf() {
    if (account) {
      const balance = new Big(await contract?.stakedAmountOf(account))
      dispatch(setBalanceLPT(balance.toString()))
    }
  }
  async function getTier() {
    const tier = await contract?.getTierOf(account)
    dispatch(setTier(Number(tier)))
  }
  async function getStakedAmount(account: string) {
    if (account) {
      const stakedAmount = await contract?.stakedAmountOf(account)

      dispatch(
        setStakedAmount(
          toFixed(amountFromWei(stakedAmount, STAKED_DECIMALS), 1),
        ),
      )
    }
  }

  return { withdrawAll, balanceOf, getStakedAmount, getTier }
}

export default useStakingContract
